// extracted by mini-css-extract-plugin
export default {"closeBtnContainer":"MultiFormTutor_closeBtnContainer__PnOBR"};